import { CommonModule } from "@angular/common";
import { Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { SORTING_LIST_TRANSLATE_BASE } from "@shared/constants/stored-documents.constants";
import { StoredDocumentSortings } from "@shared/enums/stored-document-sortings.type";
import { DropdownModule } from "primeng/dropdown";

@Component({
  selector: "app-stored-documents-list-sort",
  standalone: true,
  imports: [CommonModule, DropdownModule, FormsModule, TranslateModule],
  templateUrl: "./stored-documents-list-sort.component.html",
  styleUrl: "./stored-documents-list-sort.component.scss",
})
export class StoredDocumentsListSortComponent {
  @Input() selectedSorting: StoredDocumentSortings | undefined;
  @Input() defaultSorting: StoredDocumentSortings | undefined;
  @Output() selectedSortingChange = new EventEmitter<StoredDocumentSortings | undefined>();

  sortings: StoredDocumentSortings[];

  constructor() {
    this.sortings = Object.values(StoredDocumentSortings);
  }

  @HostBinding("class.defaultValue")
  get isDefaultValue() {
    return this.selectedSorting === this.defaultSorting;
  }

  valueChange() {
    this.selectedSortingChange.emit(this.selectedSorting);
  }

  getTranslationUri(id: string) {
    return SORTING_LIST_TRANSLATE_BASE + id;
  }
}
